var getKeys = require('./_object-keys');
var toIObject = require('./_to-iobject');
module.exports = function (object, el) {
  var O = toIObject(object);
  var keys = getKeys(O);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) if (O[key = keys[index++]] === el) return key;
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_keyof.js
// module id = 318
// module chunks = 2